(() => {
  if (window.__dnProductPolicies) return;
  window.__dnProductPolicies = true;
  const dialogStates = new WeakMap();
  function restorePagePosition(state) {
    if (state && (window.scrollX !== state.x || window.scrollY !== state.y)) {
      window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
    }
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dn-policy-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.dnPolicyOpen);
      if (!dialog?.matches('[data-dn-policy-dialog]')) return;
      event.preventDefault();
      const state = { trigger, x: window.scrollX, y: window.scrollY };
      dialogStates.set(dialog, state);
      dialog.showModal();
      const conditionBody = dialog.querySelector('[data-dn-condition-content]');
      if (conditionBody) conditionBody.scrollTop = 0;
      restorePagePosition(state);
      return;
    }
    const close = event.target.closest('[data-dn-policy-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog[data-dn-policy-dialog]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (!event.target.matches('dialog[data-dn-policy-dialog]')) return;
    const state = dialogStates.get(event.target);
    dialogStates.delete(event.target);
    let trigger = state?.trigger;
    if (trigger && (!trigger.isConnected || trigger.getClientRects().length === 0) && event.target.hasAttribute('data-dn-condition-dialog')) {
      const candidates = Array.from(document.querySelectorAll('[data-dn-policy-open]'))
        .filter((element) => element.dataset.dnPolicyOpen === event.target.id && element.isConnected && element.getClientRects().length > 0);
      trigger = candidates.find((element) => element.classList.contains('dn-condition-notes-link') === state.trigger.classList.contains('dn-condition-notes-link')) || candidates[0];
    }
    if (trigger?.isConnected) {
      if (window.DripnordProductFocus) window.DripnordProductFocus.focus(trigger);
      else trigger.focus({ preventScroll: true });
    }
    restorePagePosition(state);
  }, true);
})();
